const setHiddenSlides = (swiper) => {
	const slidesVisible = Math.floor(swiper.params.slidesPerView);

	const allSlides = swiper.el.querySelectorAll('.swiper-slide');
	allSlides.forEach((slide) => {
		slide.setAttribute('tabindex', -1);
		slide.setAttribute('aria-hidden', true);
		slide.querySelectorAll('a, button').forEach((item) => {
			item.setAttribute('tabindex', -1);
		});
	});

	let visibleSlide = swiper.el.querySelector('.swiper-slide-active');
	for (let i = slidesVisible; i > 0; i--) {
		if (null === visibleSlide) {
			break;
		}

		visibleSlide.setAttribute('aria-hidden', false);
		visibleSlide.setAttribute('tabindex', -1);
		visibleSlide
			.querySelectorAll('a, button')
			.forEach((item) => item.removeAttribute('tabindex'));

		visibleSlide = visibleSlide.nextElementSibling;
	}
};

export default setHiddenSlides;
